const TRACKER_URL = process.env.REACT_APP_TRACKER_URL;
const SESSION_KEY = "portfolio-tracked";
const SOURCE_KEY = "portfolio-source";
const REFERRER_KEY = "portfolio-referrer";
const CAMPAIGN_KEY = "portfolio-campaign";

function isLocal(): boolean {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

function send(values: Record<string, string>): void {
  if (!TRACKER_URL || isLocal()) return;

  const pixel = new URL(`${TRACKER_URL.replace(/\/$/, "")}/api/pixel`);
  Object.entries(values).forEach(([key, value]) => {
    if (value) pixel.searchParams.set(key, value);
  });
  pixel.searchParams.set("t", String(Date.now()));

  const image = new Image();
  image.referrerPolicy = "no-referrer";
  image.src = pixel.toString();
}

export function trackVisit(): void {
  if (!TRACKER_URL || isLocal()) return;

  try {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, "1");
  } catch {}

  const params = new URLSearchParams(window.location.search);
  const source = params.get("src") || params.get("utm_source") || "";
  const campaign = params.get("campaign") || params.get("utm_campaign") || "";
  const referrer = document.referrer || "";

  try {
    sessionStorage.setItem(SOURCE_KEY, source);
    sessionStorage.setItem(REFERRER_KEY, referrer);
    sessionStorage.setItem(CAMPAIGN_KEY, campaign);
  } catch {}

  send({ slug: "portfolio", ref: referrer, src: source, campaign });
}

export function trackClick(slug: "github" | "linkedin" | "resume"): void {
  let source = "";
  let referrer = "";
  let campaign = "";

  try {
    source = sessionStorage.getItem(SOURCE_KEY) || "";
    referrer = sessionStorage.getItem(REFERRER_KEY) || "";
    campaign = sessionStorage.getItem(CAMPAIGN_KEY) || "";
  } catch {}

  send({ slug, ref: referrer, src: source, campaign });
}